import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ProvidersTable } from '../../components/Providers/ProvidersTable';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';
import { useSelector } from 'react-redux';

export const Providers = () => {
  const {
    privileges: { providers: privileges = [] },
  } = useSelector((state) => state.userAuth);
  const navigate = useNavigate();

  return (
    <Card title={<TitleBreadcrumbs />} bordered={true} className="gx-card">
      {privileges.includes('create') && (
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => {
            navigate('/dashboard/proveedores/crear');
          }}
        >
          <PlusOutlined />
          Nuevo
        </Button>
      )}
      <ProvidersTable />
    </Card>
  );
};
